import React from 'react';
import { useTranslation } from 'react-i18next';
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";

const Imprint = () => {
  const { t } = useTranslation();

  return (
      <div className="flex flex-col mt-28 mb-8 py-6 px-4 sm:px-8 max-w-4xl mx-auto bg-white dark:bg-neutral-900/40 shadow-sm border border-gray-100 dark:border-white/5 rounded-2xl max-h-[85vh]">
        {/* Header Section */}
        <div className="flex flex-col items-center text-center gap-3 pt-4 pb-6 shrink-0">
          <div className="p-3 bg-blue-50 dark:bg-blue-500/10 rounded-xl text-blue-500 dark:text-dark-primary">
            <BusinessOutlinedIcon className="w-7 h-7" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
            {t("impressum.title")}
          </h1>
          <div className="w-12 h-1 bg-blue-500 dark:bg-dark-primary rounded-full mt-1" />
        </div>

        {/* Content Area with Overflow Scroll */}
        <div className="flex-1 overflow-y-auto pr-2 space-y-6 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-200 dark:scrollbar-thumb-neutral-800 text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4">
          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-4 uppercase tracking-wide">
              {t('impressum.section1_title')}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6">
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5"><span className="text-gray-400 font-medium">{t('impressum.company')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">MoonSkins</span></p>
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5"><span className="text-gray-400 font-medium">{t('impressum.address')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">Wintersbuckstr. 6</span></p>
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5"><span className="text-gray-400 font-medium">{t('impressum.phone')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">+49 1749 171817</span></p>
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5"><span className="text-gray-400 font-medium">{t('impressum.email')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">info@moonskins.gg</span></p>
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5"><span className="text-gray-400 font-medium">{t('impressum.website')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">moonskins.gg</span></p>
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5"><span className="text-gray-400 font-medium">{t('impressum.managing_director')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">Julien Chmelnik</span></p>
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5"><span className="text-gray-400 font-medium">{t('impressum.commercial_register')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">Wird nachgetragen</span></p>
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5"><span className="text-gray-400 font-medium">{t('impressum.register_number')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">Wird nachgetragen</span></p>
              <p className="flex justify-between border-b border-gray-100 dark:border-white/5 pb-1.5 sm:col-span-2"><span className="text-gray-400 font-medium">{t('impressum.vat_id')}:</span> <span className="font-semibold text-gray-800 dark:text-gray-100">Wird nachgetragen</span></p>
            </div>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t('impressum.section2_title')}
            </h2>
            <p>{t('impressum.responsible_person')}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t('impressum.section3_title')}
            </h2>
            <p>{t('impressum.content_liability')}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t('impressum.section4_title')}
            </h2>
            <p>{t('impressum.link_liability')}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("impressum.section5_title")}
            </h2>
            <p>{t("impressum.copyright")}</p>
          </section>

          <div className="text-xs text-gray-400 dark:text-neutral-600 font-medium pt-2 text-center shrink-0">
            Credits: Heroicons, IYAHICON
          </div>
        </div>
      </div>
  );
};

export default Imprint;